import posthog from 'posthog-js';

if (typeof window !== 'undefined') {
	posthog.init(process.env.VITE_PUBLIC_POSTHOG_KEY ?? '', {
		api_host: process.env.VITE_PUBLIC_POSTHOG_HOST,
	});
}

export { posthog };
